<script setup>
import { usePdfDownload } from '@/composables/usePdfDownload'
import { useToast } from '@/composables/useToast'

const props = defineProps({
  url:   { type: String, required: true },
  label: { type: String, default: 'PDF' },
})

const { downloading, error, download } = usePdfDownload()
const { error: toastError } = useToast()

async function onClick() {
  await download(props.url)
  if (error.value) toastError(error.value)
}
</script>

<template>
  <button type="button" @click="onClick" :disabled="downloading"
    class="px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-md text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 transition-all flex items-center gap-1.5 disabled:opacity-60">
    <span v-if="downloading" class="material-symbols-outlined text-sm animate-spin">progress_activity</span>
    <span v-else class="material-symbols-outlined text-sm">picture_as_pdf</span>
    {{ downloading ? 'Génération…' : label }}
  </button>
</template>
